import React, { useEffect, useRef } from 'react'
import { useStore } from 'react-redux'
import { useLocation } from 'react-router'
import type { StoreType } from 'src/store'
import { initPage } from 'utils/initUtils'
import { AuthController } from 'components/Utility/AuthController/AuthController'
import { HashRoute } from 'components/Utility/HashRoute/HashRoute'
import { PageContent } from 'components/PageElements/PageContent/PageContent'
import { AppointmentController } from 'components/Appointment/AppointmentController'
import { NavigationTop } from 'components/PageElements/NavigationTop/NavigationTop'
import { Header } from 'components/PageElements/Header/Header'
import { Loader } from 'components/Utility/Loader/Loader'

import 'reset-css/reset.css'
import './App.scss'

type AppContentProps = {
  initError: boolean,
  initLoading?: boolean,
}

export const AppContent: React.FC<AppContentProps> = (props) => {
  const { initError, initLoading = false } = props
  const location = useLocation()
  const store = useStore() as StoreType
  const prevPathname = useRef(location.pathname)

  // Load the page for every new path, and scroll to the top when the path changes
  useEffect(() => {
    if (initLoading || initError) {
      return
    }
    // eslint-disable-next-line no-console
    initPage(store, location.pathname, location.search).catch(console.error)
    if (prevPathname.current !== location.pathname) {
      window.scrollTo(0, 0)
      prevPathname.current = location.pathname
    }
  }, [store, location.pathname, location.search, initLoading, initError])

  if (initError) {
    return <div className={'init-error'}>
      Произошла ошибка при загрузке сайта!<br />
      Мы уже работаем над исправлением проблемы.
    </div>
  }

  return <div className={'App'}>
    <div className={'container'}>
      {initLoading ? (
        <Loader />
      ) : (
        <>
          <AuthController />
          <HashRoute hash={'#appointment'}>
            <AppointmentController />
          </HashRoute>
          <Header />
          <NavigationTop />
          <PageContent />
        </>
      )}
    </div>
  </div>
}
